import React, { Component } from 'react'
import { PropTypes } from 'prop-types'

import bem from '../../../common/bem'
import { InputText } from '../../ui'
export default class Searchbar extends Component {

  static defaultProps = {
    q: null
  }

  static propTypes = {
    q: PropTypes.string,
    location: PropTypes.object.isRequired
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor() {
    super()
    this._inputChange = this._inputChange.bind(this)
    this._formSubmit = this._formSubmit.bind(this)
  }

  componentWillMount() {
    this.setState({
      q: this.props.q
    })
  }

  _inputChange(evt) {
    this.setState({
      q: evt.target.value
    })
  }

  _formSubmit(evt) {
    evt.preventDefault()
    const { router } = this.context
    router.push({
      pathname: '/search',
      query: {
        q: this.state.q
      }
    })
  }

  render() {

    const bemmer = bem('searchbar')
    const { location } = this.props
    const { pathname, query } = location || {}


    return (
      <form
        className={ bemmer.element('form') }
        ref={ component => this.form }
        onSubmit={ this._formSubmit }>
        <InputText
            isSearch
            defaultValue={ pathname === '/search' ? query.q : null }
            onChange={ this._inputChange }
            placeholder='search...'
            ref={ component => this.input = component }
          />
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./component/ui/Searchbar/Searchbar.js